<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner-list">


        <div class="row">
            <div class="col-sm-9">
                <h1 class="title-default">Automações de Extração de Dados</h1>
                <p class="welcome-message">
                    <button mat-icon-button routerLink="../">
                        <mat-icon>arrow_back</mat-icon>
                    </button>
                    Apenas seu usuário tem acesso às automações de extração de dados aqui.
                </p>
            </div>
            <div class="col-sm-3">
                <a type="button" mat-flat-button class="btn-primary btn-add-right"
                    [routerLink]="['/home/ferramentas/automacao-extracao-dados/cadastrar', {idTipoExtracao: this.preselectedTipoExtracao}]">
                    <span class="material-symbols-outlined">add</span>
                    Nova automação
                </a>
            </div>
        </div>

        <div class="row search-area">
            <div class="col-12">
                <button mat-stroked-button type="button" class="btn-filter margin-right-15"
                    [matMenuTriggerFor]="filtroMenu" [matBadge]="qtdFiltrosAvancados"
                    [matBadgeHidden]="qtdFiltrosAvancados === 0">
                    <mat-icon>filter_list</mat-icon>
                    Filtrar
                </button>
                <mat-menu #filtroMenu="matMenu" class="filter-custom-menu">
                    <div class="filter-menu-content" [formGroup]="model">
                        <div (click)="$event.stopPropagation()">
                            <h6>Filtros Avançados</h6>
                            <div class="filter-menu__form">
                                <app-select-pesquisavel [control]="idTipoExtracaoControl"
                                    [offlineList]="listaTipoExtracao" label="Tipo de Extração"
                                    idField="idTipoExtracao" nameField="tipoExtracao" [isOptional]="true"
                                    [multiple]="true" [showBadges]="true">
                                </app-select-pesquisavel>
                            </div>
                        </div>
                        <div class="filter-menu__actions">
                            <button mat-button class="btn-secondary" matMenuClose>Cancelar</button>
                            <button mat-flat-button class="btn-primary" (click)="aplicarFiltros()" matMenuClose>
                                Aplicar
                            </button>
                        </div>
                    </div>
                </mat-menu>

                <button mat-stroked-button type="button" class="btn-filter" (click)="limparFiltros()">
                    <mat-icon>cleaning_services</mat-icon>
                    Limpar Filtros
                </button>
            </div>
        </div>

        @if(_dataSource.data.length > 0 && !_isLoading){
        <div class="desktop-table">
            <table mat-table [dataSource]="_dataSource">

                <ng-container matColumnDef="nomeAutomacao">
                    <th mat-header-cell *matHeaderCellDef> Nome da Automação </th>
                    <td mat-cell *matCellDef="let element">
                        <span>{{element.nomeAutomacao}}</span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="idTipoExtracao">
                    <th mat-header-cell *matHeaderCellDef> Funcionalidade / Tipo </th>
                    <td mat-cell *matCellDef="let element"> {{element.nomeTipoExtracao }} </td>
                </ng-container>

                <ng-container matColumnDef="recorrencia">
                    <th mat-header-cell *matHeaderCellDef> Período de Execução </th>
                    <td mat-cell *matCellDef="let element"> {{element.nomeTipoRecorrencia}} </td>
                </ng-container>

                <ng-container matColumnDef="datetimeUltimaExecucao">
                    <th mat-header-cell *matHeaderCellDef> Data última execução </th>
                    <td mat-cell *matCellDef="let element">
                        @if(!element.datetimeUltimaExecucao){
                        <span>Ainda não executado</span>
                        }
                        @else{
                        {{element.datetimeUltimaExecucao | date:'dd/MM/yyyy HH:mm'}}
                        }
                    </td>
                </ng-container>
                <ng-container matColumnDef="datetimeProximaExecucao">
                    <th mat-header-cell *matHeaderCellDef> Data próxima execução </th>
                    <td mat-cell *matCellDef="let element">
                        @if(element.ativo){
                        <span>{{element.datetimeProximaExecucao | date:'dd/MM/yyyy'}} </span>
                        } @else {
                        <span matTooltip="Não tem previsão de execução porque está inativo.">Não tem previsão</span>
                        }
                    </td>
                </ng-container>

                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef class="text-center"> Status </th>
                    <td mat-cell *matCellDef="let element" class="text-center">
                        @if(element.ativo){
                        <span class="status-badge badge-verde">Ativo</span>
                        } @else {
                        <span class="status-badge badge-cinza">Inativo</span>
                        }
                    </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef class="text-center w-actions">Ações</th>
                    <td mat-cell *matCellDef="let element" class="text-center w-actions">
                        <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Ações">
                            <span class="material-symbols-outlined">more_horiz</span>
                        </button>
                        <mat-menu #menu="matMenu">
                            <button mat-menu-item
                                [routerLink]="['/home/ferramentas/automacao-extracao-dados/cadastrar', {idAutomacaoExtracaoDados: element.idAutomacaoExtracaoDados}]">
                                <span class="material-symbols-outlined">edit</span>
                                <span>Editar</span>
                            </button>
                            <button mat-menu-item (click)="abrirModalExcluir(element)">
                                <span class="material-symbols-outlined">delete</span>
                                <span>Excluir</span>
                            </button>
                        </mat-menu>
                    </td>
                </ng-container>


                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>
        <div class="mobile-cards">
            @for(element of _dataSource.data; track element.idAutomacaoExtracaoDados){
            <div class="card">
                <div class="card-header">
                    <div class="card-header-title">
                        {{element.nomeAutomacao}}
                    </div>
                    <div>
                        @if(element.ativo){
                        <span class="status-badge success">Ativo</span>
                        } @else {
                        <span class="status-badge error">Inativo</span>
                        }
                    </div>
                </div>
                <div class="card-body">
                    <div class="card-row">
                        <span class="card-label">Tipo</span>
                        <span class="card-value">{{element.nomeTipoExtracao}}</span>
                    </div>
                    <div class="card-row">
                        <span class="card-label">Recorrência</span>
                        <span class="card-value">{{element.nomeTipoRecorrencia}}</span>
                    </div>
                    <div class="card-row">
                        <span class="card-label">Última Execução</span>
                        <span class="card-value">
                            @if(!element.datetimeUltimaExecucao){
                            -
                            } @else{
                            {{element.datetimeUltimaExecucao | date:'dd/MM/yyyy HH:mm'}}
                            }
                        </span>
                    </div>
                    <div class="card-row">
                        <span class="card-label">Próxima Execução</span>
                        <span class="card-value">
                            @if(element.ativo){
                            {{element.datetimeProximaExecucao | date:'dd/MM/yyyy'}}
                            } @else {
                            Não tem previsão
                            }
                        </span>
                    </div>
                </div>
                <div class="card-actions">
                    <a mat-mini-fab class="fab-action default"
                        [routerLink]="['/home/ferramentas/automacao-extracao-dados/cadastrar', {idAutomacaoExtracaoDados: element.idAutomacaoExtracaoDados}]"
                        matTooltip="Editar">
                        <mat-icon>edit</mat-icon>
                    </a>
                    <button mat-mini-fab class="fab-action default" (click)="abrirModalExcluir(element)"
                        matTooltip="Excluir">
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>
            </div>
            }
        </div>
        }

        @if(_isLoading){
        <app-loading-box-default-list></app-loading-box-default-list>
        }

        @if(!_isLoading && _dataSource.data.length === 0){
        <app-empty-list [title]="'Nenhuma automação encontrada com os filtros informados.'"></app-empty-list>
        }
    </div>
</div>